<script>
  import CardHeader from './CardHeader.svelte'
  import { slide } from 'svelte/transition'

  let isOpen = false
  const toggle = () => (isOpen = !isOpen)

  export let data = []
  export let unit
  export let headerClass
  export let title_1
  export let title_2

  const retrieveLeader = async (data) => {
    return data[0]
  }
</script>

<style>
  .card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    margin: 10px auto auto auto;
    border-radius: 5px;
  }
  .card:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  }
  header {
    padding: 1px 16px;
    border-radius: 5px 5px 0 0;
  }
  .odd {
    background-color: #ffa500;
  }
  .even {
    background-color: #f8f8f8;
  }
  .body {
    padding: 2px 16px;
  }
  .content {
    height: 400px;
    overflow-y: scroll;
  }
  button {
    border: none;
    background: none;
    display: block;
    color: inherit;
    cursor: pointer;
    margin: 0;
    padding-bottom: 0.5em;
    padding-top: 0.5em;
    width: 100%;
    text-align: left;
  }
  table {
    width: 100%;
  }
  td {
    vertical-align: text-top;
    border-bottom: lightgray solid 1px;
  }
  td.first {
    border-top: lightgray solid 1px;
  }
  td.speed {
    text-align: right;
    white-space: nowrap;
  }
  h3,
  p {
    font-family: Monserrat, sans-serif;
    margin: 2px;
  }
</style>

<div class="card">
  <header class={headerClass}>
    <button on:click={toggle} aria-expanded={isOpen}>
      <h3>{title_1}</h3>
      {#if title_2}
        <p>{title_2}</p>
      {/if}
    </button>
  </header>
  <div class="body">
    <button on:click={toggle} aria-expanded={isOpen}>
      <CardHeader report={retrieveLeader(data)} {unit} />
    </button>
    {#if isOpen}
      <div class="content" transition:slide={{ duration: 300 }}>
        <table>
          {#each data.slice(1) as { sailor, boat, reported_data, is_foiler, is_first_timer }, i}
            <tr>
              <td>{i + 2}.</td>
              <td class={i == 0 ? 'first' : ''}>
                {sailor}
                {is_first_timer == '1' ? '🐣' : ''}
                •
                <em>{boat}</em>
                {is_foiler == '1' ? '✔️' : ''}
              </td>
              <td class="{i == 0 ? 'first' : ''} speed">
                {reported_data == undefined ? '' : reported_data}
                {unit}
              </td>
            </tr>
          {/each}
        </table>
      </div>
    {/if}
  </div>
</div>
